import { createApp } from 'vue'
import ErgoAdvisor from './ErgoAdvisor.vue'
import './style.css'

/**
 * 手动挂载组件到指定元素。
 * @param {string | Element} target  CSS 选择器或 DOM 元素
 * @param {Record<string, unknown>} [props]  传给组件的 props(如 apiUrl / apiKey / accent)
 * @returns 创建的 Vue app 实例(可调用 .unmount() 销毁)
 */
export function mount(target, props = {}) {
  const el = typeof target === 'string' ? document.querySelector(target) : target
  if (!el) {
    console.warn('[ergo-advisor] 未找到挂载目标:', target)
    return null
  }
  const app = createApp(ErgoAdvisor, props)
  app.mount(el)
  return app
}

/**
 * Vue 插件形式安装(供打包器项目使用): app.use(ErgoAdvisor)
 */
export function install(app) {
  app.component('ErgoAdvisor', ErgoAdvisor)
}

/** 从自定义标签元素上读取 attribute 作为 props(跳过 class/id/data-*) */
function readPropsFromElement(el) {
  const props = {}
  for (const attr of el.attributes) {
    const { name, value } = attr
    if (name === 'class' || name === 'id' || name.startsWith('data-')) continue
    props[name] = value
  }
  return props
}

/**
 * 自动挂载:扫描页面中所有 <ergo-advisor> 标签并渲染。
 * Dify 地址与 key 已内置默认,可直接使用;
 * 如需覆盖,可通过标签 attribute 传 props,例如:
 *   <ergo-advisor api-url="https://your-backend/chat" api-key="..."></ergo-advisor>
 */
export function autoMount(root = document) {
  const els = root.querySelectorAll('ergo-advisor')
  els.forEach((el) => {
    mount(el, readPropsFromElement(el))
  })
  return els.length
}

// DOM 就绪后自动挂载(幂等:已挂载的元素会被 Vue 直接接管)
if (typeof document !== 'undefined') {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => autoMount(), { once: true })
  } else {
    autoMount()
  }
}

export { ErgoAdvisor }
export default ErgoAdvisor
